import React from 'react'
import {
  CHeader,
  CHeaderToggler,
  CHeaderBrand,
  CHeaderNav,
  CNavItem,
  CNavLink,
} from '@coreui/react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

export default function Dash_header() {
  const dispatch = useDispatch()
  const sidebarShow = useSelector(state => state.sidebarShow)

  const toggleSidebar = () => {
    dispatch({ type: 'set', sidebarShow: !sidebarShow })
  }

  return (
    <CHeader position="sticky">
      <CHeaderToggler className="ms-3" onClick={toggleSidebar} />
      <CHeaderBrand className="mx-auto d-lg-none" as={Link} to="/dashboard">
        JointPlug
      </CHeaderBrand>
      <CHeaderNav className="ms-auto me-3">
        <CNavItem>
          <CNavLink as={Link} to="/dashboard">Dashboard</CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="/logout">Logout</CNavLink>
        </CNavItem>
      </CHeaderNav>
    </CHeader>
  )
}
